module.exports = __webpack_public_path__ + "img/contact.03c0cbf0.svg";